import React from "react";

import {
  Field,
  FieldLabel,
  TwoColumnRow,
} from "../../../../components/FormPanel";
import { FormInput, SelectForm } from "../../../../components/Input";
import { CURRENCY_RULES, MANUAL_ASSET_TYPE_OPTIONS } from "./constants";
import { NameField } from "./NameField";
import { EditorWarning } from "./styles";
import { SymbolExchangeRow } from "./SymbolExchangeRow";
import { EditorFieldsProps } from "./types";

export const ManualFields: React.FC<EditorFieldsProps> = ({
  control,
  disabled,
}) => (
  <>
    <SymbolExchangeRow control={control} disabled={disabled} />
    <TwoColumnRow>
      <Field>
        <FieldLabel htmlFor="instrument-editor-asset-type">
          Asset type
        </FieldLabel>
        <SelectForm
          id="instrument-editor-asset-type"
          name="manualAssetType"
          control={control}
          options={MANUAL_ASSET_TYPE_OPTIONS}
          rules={{ required: "Choose an asset type" }}
          disabled={disabled}
        />
      </Field>
      <Field>
        <FieldLabel htmlFor="instrument-editor-currency">
          Native currency
        </FieldLabel>
        <FormInput
          id="instrument-editor-currency"
          name="nativeCurrency"
          control={control}
          rules={CURRENCY_RULES}
          disabled={disabled}
        />
      </Field>
    </TwoColumnRow>
    <NameField control={control} disabled={disabled} />
    <EditorWarning role="status">
      This ticker can&apos;t be bought until it has a price.
    </EditorWarning>
  </>
);
